<template>
    <x-dialog :visible="visible" :config="getDialogConfig(config)"
        @close="$emit('close')"
        @confirm="confirmHandler"
        @update:visible="(visible)=> $emit('update:visible', visible)"
    >
        <div class="x-form-dialog">
            <x-quick-form-view ref="form"
                :config="config"
                v-model:data="modelValue"
                :view-state="ViewState.CREATE"
            ></x-quick-form-view>
        </div>
    </x-dialog>
</template>
<script setup>
import { getCurrentInstance, ref, watch } from 'vue';
import XDialog from './XDialog.vue';
import XQuickFormView from '../viewmodule/XQuickFormView.vue';
import ViewState from '../viewmodule/ViewState';
import { ElNotification } from 'element-plus';

const inst = getCurrentInstance();

const props = defineProps({
    visible: { default: true },
    config: { default: null },
    data: { default: null },
})

defineEmits({
    'close': null,
    'update:visible': null,
    'update:modelValue': null,
    'confirm': null,
})

const getDialogConfig = (config)=> {
    if (!config) return null;
    if (!config.width) config.width = 600;
    return config;
}

const modelValue = ref(null);
watch(()=> props.data, (value)=> {
    modelValue.value = value;
}, {immediate:true})

const confirmHandler = (data, action)=> {
    data.promise = inst.refs.form['validateForm']();
    data.promise.then((valid)=> {
        if (valid) inst.emit('confirm', {data:modelValue.value}, action);
        else ElNotification({message:'数据校验失败，请检查数据准确性', title:'提示：', type:'warning'});
        return valid;
    })
}
</script>
<style>
.x-form-dialog .xm-col-item {
    padding: 5px !important;
    margin-bottom: 10px;
}
</style>